/* eslint-disable @typescript-eslint/naming-convention */
export class OfficeLocationDto {
  OfficeLocation: string;
  Company: number;
  Address: string;
  City: string;
  State: string;
  Zip: string;
  KeyID: number;
}
